<template>
  <div class="home">
    <v-form ref="formpersona" v-model="valid" @submit.prevent="guardarPersona()">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12><h2>Tipo</h2></v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select :items="tipos" label="Tipo" v-model="tipo" outline :rules="[v => !!v || 'El tipo es requerido.']"></v-select>
          </v-flex>

            <v-flex xs12></v-flex>
            <v-flex xs12 sm6>
              <v-select
                :items="jornadas"
                item-value="id"
                item-text="evento"
                v-model="jornada"
                label="Jornada / Evento"
                outline
                color="#D81B60"
                :rules="[v => !!v || 'El tipo es requerido.']"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6>
              <v-select
                :items="servicios"
                item-value="id"
                item-text="servicio"
                v-model="servicio"
                label="Servicio"
                outline
                color="#D81B60"
                :rules="[v => !!v || 'El servicio es requerido.']"
              ></v-select>
            </v-flex>

          <v-flex xs12></v-flex>

          <v-flex xs12><h2>Datos</h2></v-flex>
          <v-flex xs12 md4>
            <v-text-field
              v-model="persona.nombre"
              :rules="nombreRules"
              :counter="10"
              label="Nombre(s)"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="persona.primerApellido"
              :rules="nombreRules"
              :counter="10"
              label="Primer Apellido"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="persona.segundoApellido"
              :counter="10"
              label="Segundo Apellido"
              required
              :rules="tipo == 'EVENTO' ? [v => !!v || 'El telefono es requerido.'] : []"
            ></v-text-field>
          </v-flex>

            <v-flex xs12 md6>
              <v-autocomplete
                v-model="municipio"
                :items="municipios"
                :loading="isLoading"
                :search-input.sync="search"
                item-text="municipio"
                item-value="id"
                label="Municipio"
                placeholder="Busca el municipio"
                return-object no-filter
                autocomplete
                :rules="[v => !!v || 'El municipio es requerido.']"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 md6>
              <v-autocomplete
                v-model="localidad"
                :items="localidades"
                :loading="localidadLoading"
                :search-input.sync="buscarLocalidad"
                hide-no-data
                hide-selected
                item-text="localidad"
                item-value="id"
                label="Localidad"
                placeholder="Busca la localidad"
                return-object
                :rules="[v => !!v || 'La localidad es requerida.']"
              ></v-autocomplete>
            </v-flex>

          <v-flex xs12 md4 v-if="tipo == 'EVENTO'">
            <v-autocomplete
              v-model="cargo"
              :items="cargos"
              :loading="cargoLoading"
              :search-input.sync="buscarCargo"
              hide-no-data
              hide-selected
              item-text="nombre"
              item-value="id"
              label="Cargo"
              placeholder="Busca el cargo"
              return-object
              :rules="[v => !!v || 'El cargo es requerido.']"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 md4 v-if="tipo == 'EVENTO'">
              <v-btn
                color="red lighten-2"
                dark
                @click="dialog = true" outline
              >Agregar Cargo
              </v-btn>
          </v-flex>

          <v-flex xs12 md5 v-if="tipo == 'JORNADA'">
            <v-text-field
              v-model="persona.curp"
              :counter="18"
              label="Curp"
              required
              :rules="tipo == 'JORNADA' ? curpRules : []"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md5 v-if="tipo == 'JORNADA'">
            <v-text-field
              v-model="persona.fechaNacimiento"
              :counter="10"
              label="Fecha de Nacimiento (YYYY-MM-DD)"
              :rules="[v => !!v || 'La fecha de nacimiento es requerido.']"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md2 v-if="tipo == 'JORNADA'">
            <v-text-field
              v-model="edad"
              disabled
              label="Edad"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4 v-if="tipo == 'JORNADA'">
            <v-text-field
              v-model="persona.codigoPostal"
              :counter="10"
              label="Codigo postal"
              :rules="[v => !!v || 'El código postal es requerido.']"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4 v-if="tipo == 'JORNADA'">
            <v-text-field
              v-model="persona.telefono"
              :counter="10"
              label="Telefono"
              :rules="[
                v => !!v || 'El telefono es requerido.', 
                v => /(^undefined$)|(?:^$)|\d+|(?:S\/N)|(?:s\/n)/.test(v) || 'Solo se aceptan números.']"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4 v-if="tipo == 'JORNADA'">
            <v-autocomplete
              v-model="persona.etnia"
              :items="etnias"
              :loading="isLoadingEtnia"
              :search-input.sync="searchEtnia"
              item-text="etnia"
              item-value="id"
              label="Etnia"
              placeholder="Selecciona la etnia"
              return-object no-filter
              autocomplete
              :rules="[v => !!v || 'La Etnia es requerida.']"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 v-if="tipo == 'JORNADA'">
            <v-textarea
              label="Diagnostico"
              v-model="persona.diagnostico"
              hint="Dianostico"
            ></v-textarea>
          </v-flex>

          <v-divider></v-divider>

          <template v-if="tipo == 'JORNADA' && edad < 18">
            <v-flex xs12><h2>Responsable</h2></v-flex>
            <v-flex xs12 md4>
              <v-text-field
                v-model="persona.responsable.nombre"
                :rules="edad < 18 ? [v => !!v || 'El nombre es requerido.'] : []"
                label="Nombre(s)"
                required
                :readonly="!!evento_id"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md4>
              <v-text-field
                v-model="persona.responsable.primerApellido"
                label="Primer Apellido"
                :readonly="!!evento_id"
                :rules="edad < 18 ? [v => !!v || 'El Primer Apellido es requerido.'] : []"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md4>
              <v-text-field
                v-model="persona.responsable.segundoApellido"
                label="Segundo Apellido"
                required
                :readonly="!!evento_id"
              ></v-text-field>
            </v-flex>
          </template>

          <v-flex x12 md12>
            <v-btn color="info" type="submit" block>Guardar</v-btn>
          </v-flex>

        </v-layout>
      </v-container>
    </v-form>
    <div class="text-xs-center">
      <v-dialog
        v-model="dialog"
        width="500">
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title>Agregar nuevo cargo
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="nuevoCargo"
                  label="Cargo"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" type="button" @click.prevent="agregarCargo()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import GlogalJS from "../mixins/GlobalJs";
import vSelect from 'vue-select';
import moment from 'moment';

export default {
  name: "home",
  // components: {vSelect},
  mixins: [GlogalJS],
  props: ['evento_id','servicio_id','persona_id'],
  data() {
    return {
      tipos: ["EVENTO", "JORNADA"],
      tipo: null,
      valid: false,
      persona: {
        nombre: '',
        primerApellido: '',
        segundoApellido: '',
        cargo: null,
        curp: null,
        fechaNacimiento: null,
        telefono: null,
        codigoPostal: null,
        diagnostico: null,
        etnia: null,
        responsable: {
          nombre: null,
          primerApellido: null,
          segundoApellido: null
        }
      },
      requerido: [v => !!v || "El dato es necesario"],
      nombreRules: [
        v => !!v || "El dato es requerido"
      ],
      jornadas: [],
      jornada: null,
      servicios: [],
      servicio: null,
      municipios: [],
      municipio: null,
      isLoading: false,
      etnias: [],
      isLoadingEtnia: false,
      searchEtnia: null,
      search: null,
      localidades: [],
      localidad: null,
      localidadLoading: false,
      buscarLocalidad: null,
      cargos: [],
      cargo: null,
      buscarCargo: null,
      cargoLoading: false,
      dialog: false,
      nuevoCargo: null,
      curpRules: [
        v => !!v || "La CURP es requerida.",
        v => /^[A-Za-z]{1}[AEIOUXaeioux]{1}[A-Za-z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HMhm]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE|as|bc|bs|cc|cs|ch|cl|cm|df|dg|gt|gr|hg|jc|mc|mn|ms|nt|nl|oc|pl|qt|qr|sp|sl|sr|tc|ts|tl|vz|yn|zs|ne)[B-DF-HJ-NP-TV-Z-b-df-hj-np-tv-z]{3}[0-9A-Za-z]{1}[0-9]{1}$/i.test(v) 
        || "La CURP no es válida."
      ]
    };
  },
  mounted() {
    if(this.evento_id && this.servicio_id && this.persona_id)
      this.cargarPersonas();
  },
  computed: {
    now() {
      return moment().format('YYYY-MM-DD')
    },
    edad() {
      var a = moment(this.now);
      var b = moment(this.persona.fechaNacimiento);
      var years = a.diff(b, 'year');
      b.add(years, 'years');
      var months = a.diff(b, 'months');
      b.add(months, 'months');
      var days = a.diff(b, 'days');
      return years;
    },
  },
  watch: {
    municipio(val) {
      // this.localidades = [];
    },
    tipo(val) {
      //console.log(val);
      this.cargarJornadas(val);
      this.$refs.formpersona.resetValidation()
    },
    search (val) {
      // Items have already been loaded
      // if (this.municipios.length > 0) return
      // Val is greater than 4 characters
      if (val != null && val.length < 4) return
      // Items have already been requested
      if (this.isLoading) return
      this.isLoading = true
      // Lazily load input items
      fetch(`${this.server_api}/municipios?search=${val}`)
        .then(res => res.json())
        .then(res => {
          this.municipios = res
        })
        .catch(err => {
          //console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    buscarLocalidad (val) {
      // if (this.localidades.length > 0) return
      if (val == null || val.length < 4 || this.municipio == null) return
      if (this.localidadLoading) return
      this.localidadLoading = true
      fetch(`${this.server_api}/municipios/${this.municipio.id}/localidades?search=${val}`)
        .then(res => res.json())
        .then(res => {
          this.localidades = res
        })
        .catch(err => {
          //console.log(err)
        })
        .finally(() => (this.localidadLoading = false))
    },
    jornada (val) {
      //console.log(val);
      fetch(`${this.server_api}/eventos/${val}/servicios`)
        .then(res => res.json())
          .then(res => {
            this.servicios = res
          })
        .catch(err => {
          //console.log(err)
        })
    },
    buscarCargo (val) {
      // if (this.cargos.length > 0) return
      if (val != null && val.length < 4) return
      if (this.cargoLoading) return
      this.cargoLoading = true
      fetch(`${this.server_api}/cargos?search=${val}`)
        .then(res => res.json())
        .then(res => {
          this.cargos = res
        })
        .catch(err => {
          //console.log(err)
        })
        .finally(() => (this.cargoLoading = false))
    },
    searchEtnia (val) {
      this.isLoadingEtnia = true;
      fetch(`${this.server_api}/etnias?search=${val}`)
        .then(res => res.json())
        .then(res => { this.etnias = res })
        .catch(err => {})
        .finally(() => (this.isLoadingEtnia = false))
    }
  },
  methods: {
    cargarJornadas(tipo) {
      axios
        .get(`${this.server_api}/eventos?tipo=${tipo}`)
        .then(result => (this.jornadas = result.data))
        .catch(error => {
          //console.log(error);
          swal("Oops", "No pudimos cargar los eventos", "warning");
        });
    },
    buscarMunicipios(){
      //console.log('buscando...');
    },
    guardarPersona(){
      if (!this.$refs.formpersona.validate()) {
        return;
      }
      if (this.tipo == 'JORNADA') {
        this.guardarPersonaJornada();
      }else{
        this.guardarPersonaEvento();
      }
    },
    guardarPersonaEvento() {
      axios.post(`${this.server_api}/eventos/${this.jornada}/servicios/${this.servicio}/personas`, {
        nombre: this.persona.nombre.toUpperCase(),
        primer_apellido: this.persona.primerApellido.toUpperCase(),
        segundo_apellido: this.persona.segundoApellido.toUpperCase(),
        municipio_id: this.municipio.id,
        localidad_id: this.localidad.id,
        cargo_id: this.cargo.id,
        tipo: this.tipo
      }).then(response => { 
        swal('Great !', 'Guardado correctamente', 'success');
        this.persona.nombre = null;
        this.persona.primerApellido = null;
        this.persona.segundoApellido = null;
        this.persona.cargo = null;
        this.persona.curp = null;
        this.persona.fechaNacimiento = null;
        this.persona.telefono = null;
        this.persona.codigoPostal = null;
        this.$refs.formpersona.resetValidation()
      }).catch(error => { //console.log(error); 
        swal('Oops !', 'Algo salio mal.' + error, 'error')
      });
    },
    guardarPersonaJornada() {
      let data = {
        nombre: this.persona.nombre.toUpperCase(),
        primer_apellido: this.persona.primerApellido.toUpperCase(),
        segundo_apellido: this.persona.segundoApellido.toUpperCase(),
        municipio_id: this.municipio.id,
        localidad_id: this.localidad.id,
        curp: this.persona.curp.toUpperCase(),
        fecha_nacimiento: moment(this.persona.fechaNacimiento).format('YYYY-MM-DD'),
        telefono: this.persona.telefono,
        codigo_postal: this.persona.codigoPostal,
        etnia_id: this.persona.etnia.id,
        diagnostico: this.persona.diagnostico != null ? this.persona.diagnostico.toUpperCase() : null,
        responsable_nombre: this.persona.responsable.nombre != null ? this.persona.responsable.nombre.toUpperCase() : null,
        responsable_primer_apellido: this.persona.responsable.primerApellido != null ? this.persona.responsable.primerApellido.toUpperCase() : null,
        responsable_segundo_apellido: this.persona.responsable.segundoApellido != null ? this.persona.responsable.segundoApellido.toUpperCase() : null,
        tipo: this.tipo
      }
      if(this.evento_id && this.servicio_id && this.persona_id)
        axios.put(`${this.server_api}/eventos/${this.jornada}/servicios/${this.servicio}/personas/${this.persona_id}`, data).then(response => {
          swal('Great !', 'Guardado correctamente', 'success');
          this.$router.push('/eventos/8/personas');
          this.persona.nombre = null;
          this.persona.primerApellido = null;
          this.persona.segundoApellido = null;
          this.persona.cargo = null;
          this.persona.curp = null;
          this.persona.fechaNacimiento = null;
          this.persona.telefono = null;
          this.persona.codigoPostal = null;
          this.persona.responsable.nombre = null;
          this.persona.responsable.primerApellido = null;
          this.persona.responsable.segundoApellido = null;
          this.servicio = null;
          this.municipio = null;
          this.localidad = null;
          this.persona.diagnostico = null;
          this.$refs.formpersona.resetValidation()
        }).catch(error => { //console.log(error); 
          swal('Oops !', 'Algo salio mal' + error, 'warning') 
        });
      else
        axios.post(`${this.server_api}/eventos/${this.jornada}/servicios/${this.servicio}/personas`, data).then(response => {
          swal('Great !', 'Guardado correctamente', 'success');
          this.persona.nombre = null;
          this.persona.primerApellido = null;
          this.persona.segundoApellido = null;
          this.persona.cargo = null;
          this.persona.curp = null;
          this.persona.fechaNacimiento = null;
          this.persona.telefono = null;
          this.persona.codigoPostal = null;
          this.persona.responsable.nombre = null;
          this.persona.responsable.primerApellido = null;
          this.persona.responsable.segundoApellido = null;
          this.servicio = null;
          this.municipio = null;
          this.localidad = null;
          this.persona.diagnostico = null;
          this.$refs.formpersona.resetValidation()
        }).catch(error => { //console.log(error); 
          swal('Oops !', 'Algo salio mal.' + error, 'warning') 
        });
    },
    agregarCargo() {
      axios.post(`${this.server_api}/cargos`, {
        nombre: this.nuevoCargo.toUpperCase()
      }).then(response => {
        this.cargos.push({id: response.data.msj[0], nombre: this.nuevoCargo});
        this.dialog = false;
        this.nuevoCargo = null;
      }
      ).catch(error => { swal('Oops!', 'Ocurrio un error' + error, 'error')});
    },
    cargarPersonas() {
      axios.get(`${this.server_api}/eventos/${this.evento_id}/servicios/${this.servicio_id}/personas/${this.persona_id}`)
			.then(result =>{
        this.tipo = 'JORNADA';
        // this.persona = result.data[0];
        this.jornada = result.data[0].evento_id;
        this.servicio = result.data[0].servicio_id;
        this.municipio = { id: result.data[0].municipio_id, municipio: result.data[0].municipio };
        this.municipios.push(this.municipio);
        this.localidad = { id: result.data[0].localidad_id, localidad: result.data[0].localidad };
        this.localidades.push(this.localidad);
        this.persona.nombre = result.data[0].nombre;
        this.persona.primerApellido = result.data[0].primer_apellido;
        this.persona.segundoApellido = result.data[0].segundo_apellido;
        this.persona.cargo = result.data[0].cargo;
        this.persona.curp = result.data[0].curp;
        this.persona.fechaNacimiento = result.data[0].fecha_nacimiento;
        this.persona.telefono = result.data[0].telefono;
        this.persona.codigoPostal = result.data[0].codigo_postal;
        this.persona.diagnostico = result.data[0].observaciones;
        this.persona.etnia = {id: result.data[0].etnia_id, etnia : result.data[0].etnia};
        this.etnias.push(this.persona.etnia);
        this.persona.responsable.nombre = result.data[0].r_nombre;
        this.persona.responsable.primerApellido = result.data[0].r_primer_apellido;
        this.persona.responsable.segundoApellido = result.data[0].r_segundo_apellido;
			})
			.catch(() => { swal('Oops', 'No pudimos cargar los datos', 'warning') })

    }
  }
};
</script>

<style scoped>
.home {
  width: 100%;
  height: 100%;
}
input[type="text"]{
  text-transform: uppercase;
}
</style>
